import { useEffect } from 'react';

const useRenderTwitterEmbeds = (slug: string, update: boolean) => {
  useEffect(() => {
    const content = document.getElementById('#content-blocks');
    (window as any).twttr?.widgets?.load(content);
  }, [slug, update]);
};

export default useRenderTwitterEmbeds;
